import styled from 'styled-components'

export const DeacriptionDiv = styled.div`
  padding-top: 35px;
  padding-bottom: 30px;
  color: #fff;

  @media (min-width: 768px){
    padding-bottom: 10px;
  }

`;

export const TextDiv = styled.div`

  @media (min-width: 768px){
    padding-right: calc(30px + 10%);

    > * {
      line-height: 40px;
    }
  }
`;
